/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-props-no-spreading */
import { Text } from "@adobe/react-spectrum";
import {
  RankedTester,
  rankWith,
  RendererProps,
  uiTypeIs,
} from "@jsonforms/core";
import React from "react";
import get from "lodash/get";
import { useSelector } from "react-redux";

export const contextValueRendererTester: RankedTester = rankWith(
  4,
  uiTypeIs("ContextValue")
);

function ContextValueRenderer({ uischema }: RendererProps) {
  const value = uischema.options?.value;
  const spectrumProps = uischema.options?.spectrumProps;
  const style = uischema.options?.style;
  const isHtmlContent = uischema.options?.htmlContent;
  const contentId = uischema.options?.contentId;

  const content = useSelector((state: any) => get(state?.reduxState, value));
  if (isHtmlContent) {
    return (
      <div
        id={contentId}
        dangerouslySetInnerHTML={{ __html: content }}
        style={{ ...style }}
        data-testid="context-text-rich"
      />
    );
  }
  return (
    <Text {...spectrumProps} UNSAFE_style={style} data-testid="context-text">
      {content}
    </Text>
  );
}

export default ContextValueRenderer;
